var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 13.3,
    r: 1.5,
    opacity: 0.5,
    fill: "#050505"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 5.6h-.3V4.1c0-.3-.1-.5-.3-.7s-.5-.3-.8-.3c-.5 0-10.9 1-13 1.3C1.9 5 1 7.2 1 8.3V17.4c0 1.9 1.6 3.5 3.5 3.5h15c1.9 0 3.5-1.6 3.5-3.5V9.1c0-1.9-1.6-3.5-3.5-3.5zm-2.3-.4v.4h-4.5c1.8-.2 3.5-.3 4.5-.4zM21 17.4c0 .8-.7 1.5-1.5 1.5h-15c-.8 0-1.5-.7-1.5-1.5V9.1c0-.8.7-1.5 1.5-1.5h15c.8 0 1.5.7 1.5 1.5v8.3z",
    fill: "#050505"
  })));
}

export default SvgIconWallet;